import React from "react";
import FilterBase from "./FilterBase";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { FILTER } from "../../utils/Struct";
import DateField from "../../ui/DateField";
import TimeField from "../../ui/TimeField";
import Button from "../../ui/Button";
import { showError, showMessage } from "../../ui/Message";
import { bm_date, bm_time } from "../../utils/Utils";
import { ENUMS } from "../../utils/Enums";
import dayjs from "dayjs";
import DateInput from "../../ui/DateInput";
import SelectBox from "../../ui/SelectBox";

export default function GenericDateValue(props) {

    const { controller = "", onSave = () => { }, onClose = () => { }, filter = {}, include_time = false, edit = false } = props;

    const { value = 1, type = ""} = filter;

    let text = filter.text;
    let _data = ENUMS.CUSTOMER_FILTERS.find(item => item.value === type) || false;

    if (_data) {
        text = _data.text;
    }

    let filterDate = "";

    filterDate = filter?.value_1 || "";

const fields = [
    { key: "value_1", value: (edit) ? filterDate : "", help: "Enter date MM/DD/YY..." },
    { key: "comparison", value: (edit) ? filter.comparison : "=", help: "= equal, < less, > greater" },
    { include: true, label: "save", key: "save", value: "", help: "Press Enter to save" },
];

    const save = (tabs) => {
        const comparison = tabs.find(f => f.key === "comparison").value;
        const value_1 = tabs.find(f => f.key === "value_1")?.value || "";

        // check required dates
        if (!value_1) {
            showError({ error: "'value_1' must be provided." })
            return;
        }

        // build parts
        const fromPart = bm_date(value_1, "YYYY-MM-DD");

        const _f = {
            ...FILTER,
            type: value,
            comparison: comparison,
            value_1: fromPart,
        }

        onSave(_f, filter);
    }
    

    return (
        <FilterBase controller={controller} fields={fields} onClose={() => onClose()} onSave={save}>
            {({ editProps, update, tabs, next }) => (
                <div>
                    <Space>
                        <span>{text}</span>
                        <SelectBox
                            width={110}
                            {...editProps("comparison")}
                            options={[
                                { value: "=", label: "Equal to" },
                                { value: "<", label: "Less than"},
                                { value: ">", label: "Greater than"},
                            ]}
                        />
                        <DateInput cycle={["today", dayjs().add(-12, "months").format("YYYY-MM-DD"), dayjs().add(-180, "days").format("YYYY-MM-DD"), dayjs().add(-90, "days").format("YYYY-MM-DD")]} onFilled={(e) => { update("value_1", e); next() }} shrink={false} width={95} {...editProps("value_1")} />
                        <Button onClick={() => save(tabs)} {...editProps("save")}>Save</Button>
                    </Space>
                </div>
            )}

        </FilterBase>
    )

}